"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Cards_1 = require("./Cards");
var GamblingLimitsCards = function () {
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement(Cards_1.DepositLimit, null),
        react_1.default.createElement(Cards_1.LossLimit, null),
        react_1.default.createElement(Cards_1.BetLimit, null),
        react_1.default.createElement(Cards_1.SessionLimit, null)));
};
exports.default = GamblingLimitsCards;
